module.exports = "https://static.im-cdn.com/mjc/storefront/Runway/static/media/Arrow.846cef04.svg";